import React from "react"
import { format } from 'date-fns'
import DodonesList from 'app/dodones/list/Index'
import DodoneStartButton from 'app/dodones/shared/StartButton'
import DodoneFinishButton from 'app/dodones/shared/FinishButton'
import DodoneNextLink from 'app/dodones/shared/NextLink'
import DodoneCommentField from 'app/dodones/shared/NextLink'
import { useContext, useEffect, useState, useCallback } from "react"
import Chronometer from 'app/components/Chronometer'
import DodoneGenericStats from 'app/dodones/generic/Stats'
import update from "immutability-helper"

import DodoneContext from 'app/dodones/Context'
import HeaderContext from 'app/HeaderContext'

const StartedGeneric = () => {
  const { dodone, onTick } = useContext(DodoneContext);
  const [attributes, setAttributes] = useState({});

  const onAttributeChanged = useCallback((e) => {
    const nextAttributes = update(attributes, {
      [e.target.name]: { $set: e.target.value }
    })

    setAttributes(nextAttributes)
  }, [attributes])

  const hasChildren = dodone.children.length > 0;

  return <>
           {
             dodone.isFinished ?
               <div className="fcol flex-1 justify-center">
                 <DodoneGenericStats dodone = { dodone } />
               </div> :
             <>
               <div className="mb-d">
                 <Chronometer startedAt={ dodone.startedAt } size={ hasChildren ? 'small' : 'big' }  onTick={ onTick }/>
               </div>
               <div className="mb-d">
                 <textarea className="subtable" placeholder="Comment" name="comment" value={ attributes.comment || '' } onChange = { onAttributeChanged } />
               </div>
             </>
           }
           <DodonesList dodones={ dodone.children } />
           {
             dodone.isFinished ?
               <DodoneNextLink currentDodoneId = { dodone.id } /> :
             <DodoneFinishButton attributes = { attributes } />
           }
         </>;
}

const FinishedGeneric = () => {
  const { dodone } = useContext(DodoneContext);

  return <div className="fcol flex-1">
           <DodonesList dodones={ dodone.children } />
         </div>;
}

export default () => {
  const { dodone } = useContext(DodoneContext);
  const { setText } = useContext(HeaderContext);

  useEffect(() => {
    setText(dodone.dodoable.name)
  }, [dodone.id]);

  if(dodone.isStarted)
    return <StartedGeneric  />

  return <>
           <div className="flex-1"></div>
           <DodoneStartButton text="Start" />
         </>
};
